
export class TokenOrderedPayment {
  public id: string;
  public tokenId: string;
  public tokenDesc: string;
  public subtotal: number;
  public paymentMethod: string;
}
